import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useApp } from "@/context/AppContext";
import { translations } from "@/lib/i18n";
import { ArrowRight, ShieldCheck } from "lucide-react";

const LanguagePage = () => {
  const { setLanguage } = useApp();
  const navigate = useNavigate();

  const pick = (lang) => {
    setLanguage(lang);
    navigate("/category");
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F8FAFC] to-white flex items-center justify-center px-6 py-12">
      <div className="max-w-5xl w-full">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 h-10 px-4 rounded-full bg-[#006C35]/10 text-[#006C35] text-sm font-medium mb-6">
            <ShieldCheck className="h-4 w-4" />
            Kingdom of Saudi Arabia · المملكة العربية السعودية
          </div>
          <div className="text-2xl sm:text-3xl md:text-4xl text-slate-700 mb-2 font-semibold" dir="rtl">
            بوابة الشكاوى السعودية
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 tracking-tight mb-3">
            Saudi Complaint Portal
          </h1>
          <p className="text-slate-500 text-base sm:text-lg">Choose your language · اختر لغتك</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { code: "en", label: "English", sub: "Continue in English", dir: "ltr" },
            { code: "ar", label: "العربية", sub: "متابعة بالعربية", dir: "rtl" },
          ].map((opt, idx) => (
            <motion.button
              key={opt.code}
              data-testid={`lang-${opt.code}`}
              onClick={() => pick(opt.code)}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 + idx * 0.1, duration: 0.4 }}
              whileHover={{ y: -4 }}
              whileTap={{ scale: 0.98 }}
              dir={opt.dir}
              className="group relative bg-white border border-slate-200 rounded-2xl p-10 sm:p-12 text-start hover:border-[#006C35] hover:shadow-lg transition-all duration-300"
            >
              <div className="absolute top-6 end-6 h-10 w-10 rounded-full bg-slate-50 group-hover:bg-[#006C35] group-hover:text-white flex items-center justify-center transition-colors">
                <ArrowRight className={`h-5 w-5 ${opt.dir === "rtl" ? "rotate-180" : ""}`} />
              </div>
              <div className="text-4xl sm:text-5xl font-bold text-slate-900 group-hover:text-[#006C35] transition-colors mb-2">
                {opt.label}
              </div>
              <div className="text-slate-500 text-base">{opt.sub}</div>
            </motion.button>
          ))}
        </div>

        <div className="text-center mt-12 text-xs text-slate-400">
          Powered by AI · Files formal complaints to GACA, CST & TGA
        </div>
      </div>
    </div>
  );
};

export default LanguagePage;
